import utils from './utils/utils.glsl'
import blurFrag from './blur.frag'
import circleFrag from './circle.frag'
import copyFrag from './copy.frag'
import haloOrbFrag from './halo-orb.frag'
import haloOrbVert from './halo-orb.vert'
import line_roundFrag from './line-round.frag'
import line_roundVert from './line-round.vert'
import lineFrag from './line.frag'
import lineVert from './line.vert'
import maskImageFrag from './mask-image.frag'
import outputFrag from './output.frag'
import screenVert from './screen.vert'
import shield_backFrag from './shield-back.frag'
import shield_backVert from './shield-back.vert'
import shieldFrag from './shield.frag'
import shieldVert from './shield.vert'

export default {
  utils,
  blurFrag,
  circleFrag,
  copyFrag,
  haloOrbFrag,
  haloOrbVert,
  line_roundFrag,
  line_roundVert,
  lineFrag,
  lineVert,
  maskImageFrag,
  outputFrag,
  screenVert,
  shield_backFrag,
  shield_backVert,
  shieldFrag,
  shieldVert,
}
